import React from "react";
import { FormSections, LOVValues } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { DialogforRadioOptions } from "./DialogforRadioOptions";
import { Editor } from "primereact/editor";
interface Props {
    formSection: FormSections;
    field;
    isEng: boolean;
    callback;
}
interface State {
    pickedFieldOptions;
    confirmVisible: boolean;
    deleteIndex: number;
    dialogVisibleForRadioOptions: boolean[];

}

export class DropdownWithRichTextDesignComponent extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            pickedFieldOptions: [],
            confirmVisible: false,
            deleteIndex: -1,
            dialogVisibleForRadioOptions: []
        };
    }

    dropdownHtml = () => {
        let p = this.props.field;

        let elementListWithOptions = [];
        if (this.props.formSection.ListOfFormSubSections != null) {
            this.props.formSection.ListOfFormSubSections.forEach((subSection) => {
                let list = subSection.ListOfFormSectionElements.filter(
                    (q) =>
                        (q.Datatype === "RadioButton" ||
                            q.Datatype === "CheckGroup" ||
                            q.Datatype === "Dropdown") &&
                        q.Sequence < p.Sequence
                ).map((q) => {
                    return {
                        code: q.LoadBindName?.replace(/\s/g, ""),
                        description: this.props.isEng ? q.ENUTitle : q.FRATitle,
                    };
                });
                elementListWithOptions.push(...list);
            });
        }

        let htmlString = [];

        if (p.ListOfLOVValues == null) {
            p.ListOfLOVValues = [];
        }

        if (p.ListOfLOVValues.length === 0) {
            let lov=new LOVValues();
            lov.parent=p;
            p.ListOfLOVValues.push(lov);
        }

        p.ListOfLOVValues.forEach((lov: LOVValues, index) => {
            htmlString.push(
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-start",
                        paddingTop: "5px",
                        alignItems: "center"
                    }}
                    key={"option_" + index}
                >
                    <div style={{ marginRight: "5px" }}>{index + 1}</div>
                    <div>
                        <i className="fa fa-regular fa-circle-dot"></i>
                    </div>
                    <div style={{ width: "30%" }}>
                        <InputText
                            className="ontario-input-small"
                            placeholder={"Option " + (index + 1).toString()}
                            value={lov.code}
                            onChange={(e) => {
                                    lov.code = e.target.value;
                                this.props.isEng
                                    ? (lov.description = e.target.value)
                                    : (lov.FRADescription = e.target.value);
                                this.props.callback();
                            }}
                        ></InputText>
                    </div>

                    <div style={{ width: "60%" }}>
                        <div>
                            {/* @ts-ignore */}
                            <Editor style={{ height: 'auto' }}
                                value={this.props.isEng ? lov.richText : lov.richTextFRA}
                                onTextChange={(e) => {
                                    this.props.isEng
                                        ? (lov.richText = e.htmlValue)
                                        : (lov.richTextFRA = e.htmlValue);
                                    this.props.callback();
                                }}></Editor>
                        </div>
                    </div>

                    <div style={{ marginLeft: "10px" }}>
                        <i
                            title="Remove me"
                            className="pi pi-trash"
                            style={{ fontSize: "1rem", cursor: "pointer" }}
                            onClick={() => {
                                this.setState({ confirmVisible: true, deleteIndex: index });
                            }}
                        ></i>
                    </div>
                </div>
            );

            htmlString.push(
                <div>
                    <DialogforRadioOptions
                        ele={lov}
                        dialogVisible={this.state.dialogVisibleForRadioOptions[index]}
                        isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.state.dialogVisibleForRadioOptions[index] = false;
                                this.setState({ dialogVisibleForRadioOptions: this.state.dialogVisibleForRadioOptions });
                            }
                            this.props.callback();
                        }} />
                </div>
            )
        });




        htmlString.push(
            <div key={"addoption_" + p.Id}>
                {/* @ts-ignore */}
                <Button
                    className="p-button-rounded p-button-secondary"
                    style={{
                        cursor: "pointer",
                        margin: "5px",
                        fontSize: "90%",
                        border: "1px solid #64748B",
                        color: "#64748B",
                        background: "white"
                    }}
                    onClick={() => {
                        let newLov = new LOVValues();
                        newLov.Sequence = p.ListOfLOVValues.length;
                        newLov.parent=p;
                        p.ListOfLOVValues.push(newLov);
                        newLov.parent=p;
                        this.props.callback();
                    }}
                >
                    Add option
                </Button>
            </div>
        );

        return htmlString;
    };

    confirmRemove = () => {
        const { deleteIndex } = this.state;
        let p = this.props.field;
        p.ListOfLOVValues.splice(deleteIndex, 1);
        this.props.callback();
        this.setState({ confirmVisible: false });
    };

    render() {
        return (
            <div>
                {this.dropdownHtml()}
                {/* @ts-ignore */}
                <ConfirmDialog
                    visible={this.state.confirmVisible}
                    onHide={() => this.setState({ confirmVisible: false })}
                    message="Are you sure you want to remove this?"
                    header="Confirmation"
                    icon="pi pi-exclamation-triangle"
                    accept={this.confirmRemove}
                    reject={() => this.setState({ confirmVisible: false })}
                    closable={false}
                />
            </div>
        );
    }
}
